import { Box } from "@material-ui/core";

import { benefitData } from "../checkoutPage.constants";
import { useStyles } from "../checkoutPage.styles";

interface Props {
  hideHeader?: boolean | undefined;
}

export const Benefit = ({ hideHeader = false }: Props) => {
  const classes = useStyles();

  return (
    <Box display={"flex"} alignItems={"center"} justifyContent="center" flexDirection={"column"} m={4}>
      {!hideHeader && (
        <h2 className={classes.benefit}>
          <span className={classes.colorOrange}>Benefits</span> of choosing Swyft Energy
        </h2>
      )}
      <Box
        mt={hideHeader ? 0 : 4}
        display={"grid"}
        gridTemplateColumns={"repeat(5,1fr)"}
        gridGap={"28px"}
        alignItems={"center"}
        width={"100%"}
        justifyContent={"space-between"}
      >
        {benefitData.map((item, i) => (
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            textAlign={"center"}
            width={"100%"}
            key={i}
          >
            <img src={item.image} alt={item.image} width="100px" height={"100px"} />
            <div className={classes.benefitContent}>
              <div dangerouslySetInnerHTML={{ __html: item.label }} />
            </div>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
